export default {
    purchase: 'Αγορά athlisis',
    error: 'Εάν πιστεύετε ότι έχει γίνει λάθος, επικοινωνήστε μαζί μας στο info@athlisis.com',
    contact: 'Επικοινωνήστε μαζί μας στο info@athlisis.com',
    title: 'Ευχαριστούμε για την εγγραφή σας στο athlisis!',
    subtitle: 'Ολοκληρώστε την παραγγελία σας για να χρησιμοποιήσετε την εφαρμογή!',
    heading: 'Ενεργοποιήστε το athlisis',
    brandPanel: {
        title: 'Είστε ένα βήμα μακριά!',
        subtitle: 'Ολοκληρώστε την ενεργοποίηση και αποκτήστε πρόσβαση σε όλα τα εργαλεία του athlisis.',
        benefits: {
            unlimited: {title: 'Απεριόριστοι πελάτες & πλάνα', desc: 'Χωρίς κρυφά όρια στη χρήση.'},
            mobile: {title: 'Mobile εφαρμογή για τους πελάτες σας', desc: 'Παρακολούθηση γευμάτων και ειδοποιήσεις.'},
            support: {title: 'Υποστήριξη & ενημερώσεις', desc: 'Νέα χαρακτηριστικά και βοήθεια όποτε χρειαστείτε.'},
        }
    },
    sections: {
        payment: 'Τρόπος πληρωμής',
        document: 'Τύπος αποδεικτικού',
        billingDetails: 'Στοιχεία τιμολόγησης',
    },
    orderSummary: 'Σύνοψη παραγγελίας',
    plan: 'Athlisis Premium',
    subtotal: 'Υποσύνολο',
    discount: 'Έκπτωση',
    totalDue: 'Σύνολο προς πληρωμή',
    save: 'Εξοικονομείτε',
    securePayment: 'Ασφαλής πληρωμή μέσω Stripe',
    haveCoupon: 'Έχετε κωδικό κουπονιού;',
    applyCoupon: 'Εφαρμογή',
    removeCoupon: 'Αφαίρεση',
    perInstalment: 'ανά δόση',
    instalmentsHint: '{count} πληρωμές των {amount}€',
    paymentSchedule: 'Χρονοδιάγραμμα πληρωμής',
    now: 'Τώρα',
    dueBy: 'έως {date}',
    completeOrderBtn: 'Ολοκλήρωση παραγγελίας',
    startingPrice: 'Αρχική τιμή',
    salePrice: 'Εκπτωτική τιμή',
    pay: 'Πληρωμή',
    total: 'Ολόκληρο το ποσό',
    instalmentsLabel: '{count} Δόσεις',
    document: 'Αποδεικτικό',
    invoice: 'Τιμολόγιο',
    receipt: 'Απόδειξη',
    finalizePayment: 'Ολοκλήρωση πληρωμής',
    paymentFailed: 'Η πληρωμή δεν ολοκληρώθηκε. Δοκίμασε ξανά ή γράψε μας στο info@athlisis.com.',
    coupon: {
        name: 'Κωδικός κουπονιού',
        added: 'Ο κωδικός κουπονιού {code} ενεργοποιήθηκε επιτυχώς.',
        invalid: 'Ο κωδικός κουπονιού δεν είναι έγκυρος ή έχει λήξει.',
        failed: 'Δεν ήταν δυνατή η επαλήθευση του κωδικού. Παρακαλώ δοκιμάστε ξανά.',
    },
    placeholder: {
        occupation: 'Εισάγετε το επάγγελμά σας (τομέας δραστηριότητας της εταιρείας)',
        company: 'Εισάγετε την επωνυμία της εταιρείας σας',
        doy: 'Εισάγετε τον Α.Φ.Μ. σας',
        vat: 'Εισάγετε τη Δ.Ο.Υ. σας',
        phone: 'Εισάγετε το κινητό σας',
        address: 'Εισάγετε την διεύθυνση της εταιρείας σας'
    },
    instalmentTooltip: 'Κάθε δόση πρέπει να εξοφληθεί εντός της προθεσμίας της.',
    invoiceIntro: 'Παρακαλώ εισάγετε τα στοιχεία τιμολόγησής σας για την έκδοση του τιμολογίου σας.<br>\n' +
        'Εάν είστε επαγγελματίας στην Κύπρο, μην ξεχάσετε να βάλετε το πρόθεμα (CY).',
    vat: 'Φ.Π.Α {amount}%',
    logout: 'Αποσύνδεση;',
    connectedAs: 'Συνδεδεμένος ως <strong>{firstName} {lastName}</strong> (email: <strong>{email}</strong>)',
    expired: 'Η συνδρομή σας έχει λήξει.',
    renew: 'Ανανεώστε την τώρα κάνοντας κλικ εδώ',
    willExpireSingle: 'Η συνδρομή σας λήγει σε 1 ημέρα',
    willExpirePlural: 'Η συνδρομή σας λήγει σε {days} ημέρες',

    transaction: {
        title: 'Πληρωμή συναλλαγής',
        subtitle: 'Πληρώστε με ασφάλεια μέσω του ασφαλούς συστήματος πληρωμών.',
        payUntil: 'Πληρωμή έως',
        cost: 'Κόστος συναλλαγής',
        payTx: 'Πληρωμή συναλλαγής',
        payTxText: 'Πληρώστε άμεσα με την πιστωτική / χρεωστική σας κάρτα μέσω του ασφαλούς συστήματος πληρωμών μας.',
        invoiceText: 'Για να συνεχίσετε την πληρωμή σας με τιμολόγιο, παρακαλώ συμπληρώστε τα υποχρεωτικά στοιχεία\n' +
            '                  τιμολόγησής σας (ΑΦΜ, διεύθυνση, κινητό τηλέφωνο, επωνυμία).',
        invoiceTextBtn: 'Πατήστε εδώ για να τα συμπληρώσετε.',
    }
}